import { Component } from '@angular/core';

import * as XLSX from 'xlsx';
import { Router } from '@angular/router';
import { ToastService } from 'angular-toastify';
import { CityParkingStampListResponse } from '../../../../core/models/stamp.model';
import { Providers } from '../../../../core/models/information.model';
import { MyVehicleAllResponse } from '../../../../core/models/user.model';
import { ApiService } from '../../../../core/services/api.service';
import { ApiFormService } from '../../../../core/services/api-form.service';
import { ApiHandlerService } from '../../../../tools/services/api/handler-api/apiHandler.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { InputComponent } from '../../../../tools/forms/input/input.component';
import { PssLoadingComponent } from '../../../../tools/template/pss/pss-loading/pss-loading.component';

@Component({
  selector: 'app-stamp-discount',
  imports: [
    CommonModule,
    FormsModule,
    InputComponent,
    PssLoadingComponent,
  ],
  templateUrl: './stamp-discount.component.html',
  styleUrl: './stamp-discount.component.css'
})
export class StampDiscountComponent {

  cityparkingStampList: CityParkingStampListResponse[] = [
    {
      name: 'ทดสอบ',
      token: '',
      siteId: 0,
      siteName: '',
      clientId: 0,
      rateId: 5,
      stampLimitDay: 0,
      stampLimitMonth: 0,
      limitDay: false,
      limitMonth: false,
      startDate: new Date(),
      endDate: new Date(),
      expireDate: false,
      stamp_type: false,
      remark: 'ทดสอบ',
      status: 2,
      online: false
    }
  ];

  filteredCityparkingStampList: CityParkingStampListResponse[] | null = null;
  searchCardDiscount: string = '';

  // Site
  selectSite: number = 0
  allProviders: Providers[] = [];
  vehicle: MyVehicleAllResponse[] = [];

  // API 
  // endDate: string = new Date().toISOString().slice(0, 10);
  // startDate: string = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10);

  // Table
  currentPage: number = 1;
  pageSize: number = 10;

  // Modal
  showModalCreate: boolean = false
  showModalSome: boolean = false
  showModalSite: boolean = true
  // Loading
  isLoading: boolean = false

  constructor(
    private router: Router,
    private apiService: ApiService,
    private apiFormService: ApiFormService,
    private toast: ToastService,
    private apiHandler: ApiHandlerService
  ) {

  }
  ngOnInit() {
    this.isLoading = true;

    // Default
    this.getProviders();

    this.getCityparkingStampList()
  }

  /* -------------------------------------------- Function --------------------------------------------*/

  /* --- Style --- */
  // Table
  get totalPages(): number {
    return Math.ceil(this.cityparkingStampList.length / this.pageSize);
  }

  get paginatedData() {
    const start = (this.currentPage - 1) * this.pageSize;
    return this.cityparkingStampList.slice(start, start + this.pageSize);
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
    }
  }

  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
    }
  }


  /* --- Function --- */
  // Modal
  openCreateModal() {
    this.showModalCreate = true
  }

  /* --- CardAdvancesApprove --- */
  // ( Search )
  onSearchCardDiscount(value: any) {
    // Perform search logic here
    this.searchCardDiscount = value;

    if (this.searchCardDiscount === '') {
      this.filteredCityparkingStampList = null;
      return;
    }

    this.filteredCityparkingStampList = this.cityparkingStampList.filter(card =>
      card.name.toLowerCase().includes(this.searchCardDiscount.toLowerCase())
    );

  }
  // onClickSearch() {
  //   if ( !this.startDate || !this.endDate ) {
  //     this.toast.error('กรุณาเลือกช่วงวันที่');
  //     return
  //   }
  //   this.getCityparkingStampList();
  // }

  navigateToDetailCreate() {
    this.router.navigate([`/stamp-discount-details`]);
    //console.log("id :", id , this.router.url);
  }
  navigateToDetailById(id: number) {
    this.router.navigate([`/stamp-discount-details/${id}`]);
    //console.log("id :", id , this.router.url);
  }
  onSaveModal() {
    this.showModalSome = false
  }
  onSaveCreateModal() {
    this.showModalSome = false
  }

  /* -------------------------------------------- API --------------------------------------------*/
  /* --- Default --- */
  getProviders() {
    this.apiHandler.handleApi(
      this.apiFormService.getProviders(),
      {
        logLabel: 'getProvider',
        isConsoleLog: true,
        loading: (loading: boolean) => this.isLoading = loading,
        success: (response: any) => {
          this.allProviders = response;
        },
      }
    );
  }

  async getCityparkingStampList() {
    this.apiHandler.handleApi(
      this.apiService.getCityparkingStampList(),
      {
        logLabel: 'getCityparkingStampList',
        isConsoleLog: true,
        loading: (loading: boolean) => this.isLoading = loading,
        success: (response: CityParkingStampListResponse[]) => {
          this.cityparkingStampList = response;
        },
        error: (error) => {
          this.toast.error('เกิดข้อผิดพลาดในการดึงข้อมูล');
        }
      }
    )
  }

}